import { Search, X } from "lucide-react";

// The search box above every big list. Search runs on the server, across
// every record — not just what's loaded on screen.
export default function ListSearchBar({ value, onChange, placeholder, testId = "list-search", children }) {
  return (
    <div className="mt-5 flex flex-wrap items-center gap-2">
      <div className="relative flex-1 min-w-[220px] max-w-xl">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId}
          className="w-full h-10 pl-9 pr-8 rounded-lg border border-slate-200 bg-white text-sm outline-none focus:border-sky-400"
        />
        {value && (
          <button type="button" onClick={() => onChange("")} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700" title="Clear search">
            <X size={14} />
          </button>
        )}
      </div>
      {children}
    </div>
  );
}

export function LoadMore({ items, nextCursor, loadMore, loadingMore, total }) {
  if (!items || (!nextCursor && !total)) return null;
  return (
    <div className="mt-4 flex items-center justify-between gap-3 text-[12.5px] text-slate-500">
      <span>Showing {items.length.toLocaleString()}{total != null ? ` of ${total.toLocaleString()}` : ""}</span>
      {nextCursor && (
        <button onClick={loadMore} disabled={loadingMore} data-testid="load-more-button" className="h-9 px-4 rounded-lg border border-slate-200 bg-white font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-60">
          {loadingMore ? "Loading…" : "Load more"}
        </button>
      )}
    </div>
  );
}
